/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.detail.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.passes',
  'acme.common.service.helpers'
])

.controller('PassesDetailController', ['$scope', '$state', '$location', '$timeout', 'ApiService', 'HelpersService', 'PassesService', function($scope, $state, $location, $timeout, ApiService, HelpersService, PassesService) {

    $scope.passesDetail = {

      model: {},

      cap: HelpersService.cap,

      init: function() {

        if ($state.params) {
          if ($state.params.id) {
            this.getPassTemplate($state.params.id);
          }
        }

        $scope.$emit('Application::contentTitleChange', {
          title: 'View Pass Program',
          buttonLeft: {
            label: 'Close',
            permissions: 'PASS_RANGES_VIEW',
            action: function() {
              $scope.passesDetail.cancel();
            }
          }
        });
      },

      getPassTemplate: function(id) {
        ApiService.passes.detail({ id: id }).then(this.success.getPassTemplate, this.error.getPassTemplate);
      },

      isState: function (path) {

        var location = $location.path();

        return (location.indexOf(path) !== -1);

      },

      getState: function (name) {

        var stateName = 'application.passes.detail',
            stateParams = {
              id: $state.params.id
            };

        stateName += '.'+name;

        $state.go(stateName, stateParams);

      },

      cancel: function() {
        $state.go('application.passes.list');
      },

      edit: function() {
        $state.go('application.passes.edit.series', { id: $state.params.id });
      },

      success: {
        init: function(response) {},
        getPassTemplate: function(response) {

          var titleBar = {},
              self = $scope.passesDetail;

          PassesService.setModel(response.data.payload);
          self.model = PassesService.getModel();
          // next tick
          $timeout(function() {
            $scope.$broadcast('PassesDetailController::UpdateModel');
          }, 0);

          titleBar.title = 'View Pass Program';
          titleBar.buttonLeft = {
            label: 'Close',
            permissions: 'PASS_RANGES_VIEW',
            action: function() {
              $scope.passesDetail.cancel();
            }
          };

          if (self.model.state === 'draft') {
            titleBar.buttonRight = {
              label: 'Edit',
              permissions: 'PASS_RANGES_UPDATE',
              action: function() {
                $scope.passesDetail.edit();
              }
            };
          }

          $scope.$emit('Application::contentTitleChange', titleBar);

        }

      },

      error: {
        init: function(response) {},
        generic: function(response) {
          var self = $scope.passesDetail;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        getPassTemplate: function(response) {
          $scope.passesDetail.error.generic(response);
        }
      }

    };

    $scope.passesDetail.init();

}]);